export const COPYRIGHT_CONTACT_US_LINK =
  "https://share.hsforms.com/1CK8Y0vv-TuOeBbDac-CMTgbvumd";
